import React, {useMemo, useState} from "react";
import classnames from "classnames";
import {
    TimelineConnector,
    TimelineContent,
    TimelineDot,
    TimelineItem as MuiTimelineItem,
    TimelineOppositeContent,
    TimelineSeparator
} from "@mui/lab";
import {ReactComponent as SpecialDot} from "../../../../../assets/images/timeline/special-dot.svg";
import {ReactComponent as Dot} from "../../../../../assets/images/timeline/dot.svg";

/**
 * @param {string} className
 * @param {Partial<TimelineData & {withConnector: boolean}>} item
 * @param {boolean} multiple
 * @param {TimelineSelection} selection
 * @param {function} toggleSelection
 * @param {boolean} ends
 * @param {boolean} hideConnector
 * @return {JSX.Element}
 * @constructor
 */
const TimelineItem = ({className, item, selection, multiple, toggleSelection, ends, hideConnector}) => {
    const [hovered, setHovered] = useState(false);

    /**
     * Determines if the given item is selected or not.
     * @type {boolean}
     */
    const itemSelected = useMemo(() => {
        if (ends)
            return false;
        if (!multiple) {
            return selection === item?.id && selection !== null && typeof selection !== 'undefined'
        }
        return selection?.includes(item?.id) ?? false;

    }, [selection, ends, multiple, item])

    return (
        <>
            <MuiTimelineItem className={classnames(
                'timeline-item',
                className,
                {
                    'ends': ends,
                    'hover': hovered,
                    'selected': itemSelected,
                    'ignore': ends || !item?.toggleable,
                }
            )}>
                <TimelineOppositeContent>
                    <div
                        onMouseEnter={() => setHovered(true)}
                        onMouseLeave={() => setHovered(false)}
                        onClick={() => toggleSelection && toggleSelection(item)}
                        className={'timeline-content'}
                    >
                        {item?.content}
                    </div>
                </TimelineOppositeContent>
                <TimelineSeparator className={'timeline-separator'}>
                    <TimelineDot
                        className={'timeline-dot'}
                        onMouseEnter={() => setHovered(true)}
                        onMouseLeave={() => setHovered(false)}
                        onClick={() => toggleSelection && toggleSelection(item)}
                    >
                        {
                            ends
                                ? <SpecialDot className={'dot'}/>
                                : <Dot className={'dot'}/>
                        }
                    </TimelineDot>
                    {
                        !hideConnector &&
                        <TimelineConnector className={'timeline-connector'}/>
                    }
                </TimelineSeparator>
                <TimelineContent>
                    <div
                        className={'timeline-opposite-content'}
                        onMouseEnter={() => setHovered(true)}
                        onMouseLeave={() => setHovered(false)}
                        onClick={() => toggleSelection && toggleSelection(item)}
                    >
                        {item?.oppositeContent}
                    </div>
                </TimelineContent>
            </MuiTimelineItem>
        </>
    )
}

export default TimelineItem;
